import {
  addToLocationSelection,
  emptyLocationSelection,
  setFirstMunicipality,
} from "../../actions";
import { searchLocation } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import Icon from "@identitybuilding/idb-react-iconlib";
import React, { useEffect, useState } from "react";
import Axios from "axios";

const MunicipalitySelection = ({ location_value }) => {
  let { lang, nis, translate } = useSelector((state) => state.general);
  let search = useSelector((state) => state.search);

  const dispatch = useDispatch();
  const [municipalities, setMunicipalities] = useState([]);

  const setNis = (e) => {
    dispatch(emptyLocationSelection());
    dispatch(addToLocationSelection(e));
  };

  
  useEffect(() => {
    const setNis = (e) => {
      dispatch(emptyLocationSelection());
      dispatch(addToLocationSelection(e));
    };

    const setInitialNis = async () => {
      if (nis) {
        // const locByName = await searchLocation({
        //   lang: lang,
        //   name: nis.toLowerCase(),
        //   nis,
        //   translate,
        // });
        // if (search.location.length === 0) {
        //   dispatch(addToLocationSelection(locByName));
        //   dispatch(setFirstMunicipality(locByName));
        // }

        // let loc = [];
        // loc.push(locByName);
        // for (let i = 0; i < locByName && locByName.children.length; i++) {
        //   loc.push(locByName.children[i]);

        //   if (locByName.children[i].slug === location_value)
        //     setNis(locByName.children[i]);
        // }
        // setMunicipalities(loc);
        let location = "";
        let filteredName = nis
          .toLowerCase()
          // .replace(/è/g, "e")
          // .replace(/é/g, "e")
          // .replace(/ê/g, "e")
          // .replace(/ë/g, "e")
          // .replace(/á/g, "a")
          // .replace(/à/g, "a")
          // .replace(/â/g, "a")
          // .replace(/ä/g, "a")
          // .replace(/ü/g, "u")
          // .replace(/û/g, "u")
          .replace("(stad)", "")
          .replace("(ville)", "")
          .replace("(stadt)", "")
          .replace("city", "")
          .replace(" ", "")
          .replace("lalouviere", "la louvière")
          .replace("lalouvière", "la louvière")
          .replace("lacalamine", "la calamine")
          .replace("labruyere", "la-bruyere")
          .replace("labruyère", "la-bruyere")
          .replace("labruyère", "la-bruyere")
          .replace("lahulpe", "la hulpe")
          .replace('s-gravenbrakel', "gravenbrakel")
          .replace('louveigne', "louveigné")

          .replace("œ", "oe");

        if (filteredName === "depanne") { filteredName = "de panne" }
        if (filteredName === "depinte") { filteredName = "de pinte" }
        if (filteredName === "dehaan") { filteredName = "de haan" }
        const location_by_name_model =
          require("../../models/LocationByName").default;
        let option = {
          from: 0,
          size: 30,
          query: {
            query_string: {
              query: `${filteredName}`,
              fields: [
                `name_nl`,
                `name_fr`,
                `name_de`,
                `name_en`,
                `alt_name_nl`,
                `alt_name_fr`,
                `submunicipality_set.name_nl`,
                `submunicipality_set.name_fr`,
                `submunicipality_set.name_de`,
                `submunicipality_set.name_en`,
                'slug'
              ],
              tie_breaker: 0.3,
            },
          },
        };
        Axios.get(
          `${process.env.REACT_APP_BASE_MEDIA_URL2}municipalities/_search`,
          {
            auth: {
              username: `${process.env.REACT_APP_ESUSERNAME}`,
              password: `${process.env.REACT_APP_ESPSW}`,
            },
            params: {
              source_content_type: "application/json",
              source: JSON.stringify(option),
            },
          }
        )
          .then((res) => {
            let data = res.data.hits.hits[0]._source;
            location = location_by_name_model(
              translate,
              data,
              lang,
              "municipality"
            );

            if (search.location.length === 0) {
              dispatch(addToLocationSelection(location));
              dispatch(setFirstMunicipality(location));
            }

            let loc = [];
            loc.push(location);
            for (let i = 0; i < location && location.children.length; i++) {

              if (location.children[i].slug === location_value)
                setNis(location.children[i]);
            }
            setMunicipalities(loc);

          })
          .catch((err) => (err ? err : ""));
      }
    };
    setInitialNis();
    // }, [dispatch, lang, location_value, nis, search.location.length, translate]);
  }, [dispatch, lang, location_value, nis, translate]);

  const setLocationValue = (loc) => {
    if (!loc || typeof loc !== "object") return null; // Handle undefined `loc`

    return (
      <>
        {loc.postal_code && <span style={{ paddingRight: "6px" }}>{loc.postal_code}</span>}
        {loc.name}
      </>
    );
  };

  // const show_type = (nis) => nis ? nis.substring(nis.length - 1, nis.length) === "A" ? `(${translate("sub_municipality")})` : "" : ""
  return (
    search.location.length > 0 && (
      <div className="select sub_muni_selection">
        <div className="selected">
          {Array.isArray(search.location[0]) && search.location[0].length > 0
            ? setLocationValue(search.location[0][0])
            : setLocationValue(search.location[0])}
          <Icon name="ArrowDown" />
        </div>
        <div className="options">
          {/* show the municipality */}
          {municipalities &&
            municipalities.map((loc, index) => {
              return (
                <React.Fragment key={index}>
                  {loc.type && (
                    <span className="subMuniTitle">
                      {translate("municipality")}:
                    </span>
                  )}
                  <div
                    className={`option ${loc.slug === search.location[0].slug ? "active" : ""
                      }`}
                    onClick={() => setNis(loc)}
                  >
                    {setLocationValue(loc)}
                  </div>
                  {/* show the submunicipalities */}
                  {loc.children && loc.children.length > 1 && loc.type && (
                    <span className="subMuniTitle">
                      {translate("sub_municipalities")}:
                    </span>
                  )}
                  {loc.children &&
                    loc.children.length > 1 &&
                    loc.children.map((child, i) => {
                      return (
                        <div
                          className={`option ${child.slug === (search.location.length > 0 ? search.location[search.location.length - 1].slug : "") ? "active" : ""

                              ? "active"
                              : ""
                            }`}
                          onClick={() => setNis(child)}
                          key={i}
                        >
                          {setLocationValue(child)}
                        </div>
                      );
                    })}
                </React.Fragment>
              );
            })}
        </div>
      </div>
    )
  );
};

export default MunicipalitySelection;
